<section class="login-wrapper reset-wrapper">
  <div class="left-set">
    <div class="img-wrapper">
      <img src="assets/images/etp-bg.webp" alt="Login Image" />
    </div>
  </div>
  <div class="right-set">
    <div class="logo-wrapper">
      <img src="assets/images/login-img.png" alt="Logo" />
    </div>

    <div *ngIf="!tokenValid" class="invalid-token">
      <div class="svg-wrapper">
        <svg
          width="78px"
          height="78px"
          viewBox="0 0 1024 1024"
          class="icon"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M511.9 183c-181.8 0-329.1 147.4-329.1 329.1s147.4 329.1 329.1 329.1S841 693.9 841 512.2 693.6 183 511.9 183z m0 585.2c-141.2 0-256-114.8-256-256s114.8-256 256-256 256 114.8 256 256-114.9 256-256 256z"
              fill="#0F1F3C"
            ></path>
            <path
              d="M475.4 365.7h73.1v182.9h-73.1zM475.4 585.1h73.1v73.1h-73.1z"
              fill="#0F1F3C"
            ></path>
          </g>
        </svg>
      </div>
      <div><h6>Oops! Link Expired</h6>
        <a href="/forgot-password">Back to Forgot Password?</a>
      </div>
    </div>

    <div class="form-wrapper" *ngIf="tokenValid">
      <h2 class="cmn-heading-1">Reset Password</h2>
      <div class="form-content">
        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <mat-form-field>
              <mat-label>Enter new password</mat-label>
              <input
                matInput
                [type]="hide() ? 'password' : 'text'"
                id="newPassword"
                formControlName="newPassword"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="clickEvent($event)"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide()"
                type="button"
              >
                <mat-icon>{{
                  hide() ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              <!-- Error handling for required and custom validators -->
              <mat-error
                *ngIf="
                  resetPasswordForm.get('newPassword')?.hasError('required')
                "
              >
                <span>Password is required</span>
              </mat-error>
              <mat-error
                *ngIf="
                  resetPasswordForm.get('newPassword')?.hasError('minlength')
                "
              >
                <span>Password must be at least 6 characters long</span>
              </mat-error>
              <mat-error
                *ngIf="
                  resetPasswordForm
                    .get('newPassword')
                    ?.hasError('passwordStrength')
                "
              >
                <span
                  >Must include uppercase letters, lowercase letters,
                  digits.</span
                >
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <mat-label>Confirm password</mat-label>
              <input
                matInput
                [type]="hide() ? 'password' : 'text'"
                id="confirmPassword"
                formControlName="confirmPassword"
              />
            </mat-form-field>
          </div>
          <div class="form-sub-set">
            <h3 class="frgt-btn">
              Back to <span routerLink="/login">Login</span>
            </h3>
          </div>
          <div class="btn-wrapper">
            <button type="submit" [disabled]="loading">Change Password</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
